/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
"use strict";
var d3 = require("d3");
var rTree_1 = require("./rTree");
/**
 * Implementation of {IEntityStore} that uses an array for easy iteration as
 * well as a quad tree for fast nearest-point queries.
 *
 * Note that if the position of your entities changes, you MUST rebuild the
 * entity store for the `entityNearest` method to work since the quadtree does
 * not know that its nodes have moved.
 */
var EntityStore = (function () {
    function EntityStore() {
        this._entities = [];
        this._rtree = new rTree_1.RTree();
        this._tree = d3.quadtree()
            .x(function (d) { return Math.floor(d.position.x); })
            .y(function (d) { return Math.floor(d.position.y); });
    }
    EntityStore.prototype.addAll = function (entities, entityBoundsFactory, bounds) {
        (_a = this._entities).push.apply(_a, entities);
        // filter out of bounds entities if bounds is defined
        if (bounds !== undefined) {
            var filterBounds = rTree_1.RTreeBounds.bounds(bounds);
            for (var i = 0; i < entities.length; i++) {
                var entity = entities[i];
                var entityBounds = rTree_1.RTreeBounds.entityBounds(entityBoundsFactory(entity));
                if (rTree_1.RTreeBounds.isBoundsOverlapBounds(filterBounds, entityBounds)) {
                    this._tree.add(entity);
                    this._rtree.insert(entityBounds, entity);
                }
            }
        }
        else {
            this._tree.addAll(entities);
            for (var i = 0; i < entities.length; i++) {
                var entity = entities[i];
                var entityBounds = rTree_1.RTreeBounds.entityBounds(entityBoundsFactory(entity));
                this._rtree.insert(entityBounds, entity);
            }
        }
        var _a;
    };
    EntityStore.prototype.entityNearest = function (queryPoint) {
        return this._tree.find(queryPoint.x, queryPoint.y);
    };
    EntityStore.prototype.entitiesInBounds = function (bounds) {
        return this._rtree.intersect(rTree_1.RTreeBounds.entityBounds(bounds));
    };
    EntityStore.prototype.entitiesInXBounds = function (bounds) {
        return this._rtree.intersectX(rTree_1.RTreeBounds.entityBounds(bounds));
    };
    EntityStore.prototype.entitiesInYBounds = function (bounds) {
        return this._rtree.intersectY(rTree_1.RTreeBounds.entityBounds(bounds));
    };
    EntityStore.prototype.entities = function () {
        return this._entities;
    };
    return EntityStore;
}());
exports.EntityStore = EntityStore;



//////////////////
// WEBPACK FOOTER
// ./~/plottable/build/src/utils/entityStore.js
// module id = 1008
// module chunks = 0